export default function anonymous(it
) {
var out='<aside class="hi-cookie available-consent-banner"><div class=\'buttons '+(it.positionClass)+'\'><button class="renew-consent" translate>Renew Cookie Consent</button></div></aside>';return out;
}